export function Profile() {
  return (
    <div>
      <h2 style={{ marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>Profile</h2>
      <div style={{ background: "white", padding: "24px", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
        <p>This is the profile page content. Here you can manage your profile settings.</p>
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px" }}>User Information</h3>
          <p>
            <strong>Name:</strong> Gaurav Gambhir
          </p>
          <p>
            <strong>Email:</strong> gaurav@example.com
          </p>
          <p>
            <strong>Status:</strong> Online
          </p>
        </div>
      </div>
    </div>
  )
}
